import { render, staticRenderFns } from "./sellerRegistrationForm.vue?vue&type=template&id=e5aa19c8"
import script from "./sellerRegistrationForm.vue?vue&type=script&lang=js"
export * from "./sellerRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./sellerRegistrationForm.vue?vue&type=style&index=0&id=e5aa19c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports